<div class="main">
  <h2>Database</h2>
  <dx-tree-view class="treeview" [width]="'100%'" [searchEnabled]="true" searchMode="contains" noDataText="" showCheckBoxesMode="selectAll" selectionMode="multiple" [selectNodesRecursive]="true"
    [selectByClick]="true" (onSelectionChanged)="onSelectionChanged()">
  </dx-tree-view>
</div>
